/**
 * Alarme caisse/cuisine « nouvelle commande » (logique pure, testable).
 *
 * Contexte (fix 22/06) : la caisse doit SONNER à chaque nouvelle commande, y compris quand
 * le Realtime est tombé. Le service worker (sw-push.js) envoie alors un message
 * { type: 'NEW_ORDER_ALERT' } à la fenêtre caisse ouverte, qui joue l'alarme — uniquement
 * si le son est activé. Cette logique est isolée ici pour être verrouillée par un test
 * (criticité 🔴 P0 : commande → cuisine).
 */

export const NEW_ORDER_ALERT = 'NEW_ORDER_ALERT' as const;

/** Nombre de bips de l'alarme et écart entre eux (ms). */
export const ALARM_BEEPS = 6;
export const ALARM_GAP_MS = 500;

/** Vrai si le message reçu du service worker est une alerte « nouvelle commande ». */
export function isNewOrderAlert(data: unknown): boolean {
  return !!data && typeof data === 'object' && (data as { type?: unknown }).type === NEW_ORDER_ALERT;
}

/**
 * Décision centrale : faut-il déclencher l'alarme pour ce message ?
 * Vrai uniquement si c'est une alerte « nouvelle commande » ET que le son est activé.
 */
export function shouldRingForMessage(data: unknown, soundOn: boolean): boolean {
  return soundOn && isNewOrderAlert(data);
}

/** Planning des bips (offsets en ms depuis maintenant) : [0, 500, 1000, …]. */
export function alarmSchedule(beeps: number = ALARM_BEEPS, gapMs: number = ALARM_GAP_MS): number[] {
  return Array.from({ length: Math.max(0, beeps) }, (_, i) => i * gapMs);
}
